export function __downloadFile (fileSrc, fileName = 'downloaded_file', extension = '.xls') {
  const link = document.createElement('a')
  link.style = 'display: none'
  link.download = `${fileName}${extension}`
  link.href = fileSrc
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
}

export function __downloadFileWithoutExtension (file, filePath) {
  const link = document.createElement('a')

  link.download = filePath
  link.href = URL.createObjectURL(file)
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
}
